import ServicePage from "./page";
import { travelInsuranceData } from "@/mocks/insurancePages";

export default function TravelInsurance() {
  return <ServicePage data={travelInsuranceData} />;
}